module.exports = __webpack_public_path__ + "img/wrench.2ccdae0f.svg";